import React from 'react'
import Section from './Section'
import styled from '@emotion/styled'
import ConditionTwoButtonsModal from '../condition/ConditionTwoButtonsModal'
import { useState } from 'react'

const ConditionTierSection = ({ setShowModal, setIsChanged, canEdit, ConditionTierSection, ConditionTierList, offer, showModal, calculateViewChange, prospectDocuments, urlState, saveQuestionResponse, navigateWithState, ...props }) => {
  const initialConditionTier =
    urlState && urlState['qc/ConditionTierSelection'] && urlState['qc/ConditionTierSelection'].v !== undefined && urlState['qc/ConditionTierSelection'].v !== '' ? urlState['qc/ConditionTierSelection'].v : offer.conditionTierSelection
  const [conditionTier, setConditionTier] = useState(initialConditionTier)
  const [conditionTierDescription, setConditionTierDescription] = useState(offer.conditionTierList.find(x => x.name === initialConditionTier).description)

  const SetConditionTierExcellent = () => {
    navigateWithState({ ['qc/ConditionTierSelection']: { v: 'Excellent' } })
    setConditionTier('Excellent')
    setConditionTierDescription(offer.conditionTierList.find(x => x.name === conditionTier).description)
  }
  const onClickPositive = () => {
    SetConditionTierExcellent()
    setShowModal(false)
  }
  const onClickNegative = () => {
    setShowModal(false)
  }
  const component = (
    <Section title={'Condition Tier Selection'} showEdit={false}>
      <ConditionTier>
        {conditionTier}: {conditionTierDescription}
      </ConditionTier>
      <p>
        (If the user doesn’t identify any condition items, we require them to select a condition tier. If you make any edits to the condition below, it will override the condition tier selected. Or you can set the condition tier selection to excellent
        condition.)
      </p>
      {conditionTier !== 'Excellent' && (
        <SetExcellentLink data-testid={`vc-btn-condition-tier-selection`} onClick={() => setShowModal(true)}>
          Set Condition Tier Selection to Excellent
        </SetExcellentLink>
      )}
      <ConditionTwoButtonsModal
        name={'ConditionTierSelectionExcellent'}
        testId={`vc-condition-tier-selection`}
        positiveCopyOverride={'Yes'}
        onClickPositive={() => onClickPositive()}
        negativeCopyOverride={'Cancel'}
        onClickNegative={() => onClickNegative()}
        title={'Condition Tier Selection'}
        open={showModal}
        minHeight={'100px'}
        closeOnClickOutside={false}>
        This vehicle has a condition tier of {conditionTier}. Are you sure you want to set the condition tier to Excellent?
      </ConditionTwoButtonsModal>
    </Section>
  )
  let uniqueViewStr = conditionTier + ':' + conditionTierDescription
  calculateViewChange('conditiontierselection', uniqueViewStr)

  return component
}
const VerifiedByIconDiv = styled.span`
  margin-right: 15px;
`
const SetExcellentLink = styled.a`
  cursor: pointer;
  :hover {
    text-decoration: none;
  }
`
const ConditionTier = styled.span`
  font-weight: bold;
`
export default ConditionTierSection
